import {
  ContentType,
  GridData,
  StaticContentType,
} from '@bm-js/atlascloud-shared'
import StaticContentSwitcher from './StaticContentSwitcher'
import { useEditorActions } from '../../utils/hooks'
import GridContentWrapper from './GridContentWrapper'
import GridContent from './GridContent'

type Props = {
  content: ContentType<unknown>
}

const TopLevelContentSwitcher = ({ content }: Props) => {
  const { setActiveContent } = useEditorActions()
  if (content.name === 'grid') {
    return (
      <GridContentWrapper content={content as ContentType<GridData>}>
        <GridContent gridContent={content as ContentType<GridData>} />
      </GridContentWrapper>
    )
  }

  return (
    <div onClick={() => setActiveContent(content.uuid)}>
      <StaticContentSwitcher content={content as StaticContentType<unknown>} />
    </div>
  )
}

export default TopLevelContentSwitcher
